<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>

      @if (paper(); as paper) {
        <span class="header-action" (click)="viewDetails(paper)">{{ paper.title }}</span>
      } @else {
        {{ embeddingResult().paperId }}
      }
    </mat-card-title>
    <mat-card-subtitle>Score: {{ embeddingResult().score }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <p>{{ embeddingResult().text }}</p>
  </mat-card-content>
</mat-card>
